import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategoryNav() {
  const displayCategories = categories.slice(0, 8);

  return (
    <section className="w-full px-4 md:px-6 py-8 md:py-10 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-lg md:text-xl font-bold text-foreground-950 font-heading">电影分类</h2>
          <Link to="/category/all" className="text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap">
            查看全部 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-3">
          {displayCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={cat.slug === 'all' ? '/' : `/category/${cat.slug}`}
              className="group flex flex-col items-center gap-2 p-4 bg-background-50 rounded-lg hover:bg-accent-500/5 border border-background-200/60 hover:border-accent-500/20 transition-all cursor-pointer"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-full bg-accent-500/10 group-hover:bg-accent-500/20 transition-colors">
                <i className={`text-lg text-accent-600 ${getCategoryIcon(cat.slug)}`}></i>
              </div>
              <span className="text-xs text-foreground-700 group-hover:text-accent-600 transition-colors whitespace-nowrap font-medium">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function getCategoryIcon(slug: string): string {
  const iconMap: Record<string, string> = {
    all: 'ri-apps-line',
    latest: 'ri-fire-line',
    action: 'ri-sword-line',
    comedy: 'ri-emotion-laugh-line',
    scifi: 'ri-rocket-line',
    romance: 'ri-heart-line',
    horror: 'ri-ghost-line',
    classic: 'ri-trophy-line',
    animation: 'ri-palette-line',
    documentary: 'ri-earth-line',
  };
  return iconMap[slug] || 'ri-film-line';
}